<template>
  <div>
    <vs-card>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="2" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              :placeholder="placeholderbaslangic"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-col>

          <b-col lg="2" sm="5">
            <b-form-datepicker
              id="datepickerbitis"
              v-model="datepickerbitis"
              :placeholder="placeholderbitis"
              local="en"
              today-variant="danger"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="getTeklifOnayList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="3" sm="5">
            <v-select
              v-model="secilenDurum"
              :options="durumOptions"
              label="name"
              placeholder="Aktif"
              style=""
            >
            </v-select>
          </b-col>

          <b-col>
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              size=""
              @click="getTeklifOnayList()"
              >Listele</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>

    <vs-card style="height: 500px">
      <ag-grid-vue
        :rowDragManaged="true"
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="teklifOnayColumns"
        :rowData="teklifOnayList"
        :localeText="localeText"
        :rowSelection="rowSelection"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :enableCellChangeFlash="true"
        @cell-value-changed="onCellValueChanged"
        :pagination="true"
        :suppressRowClickSelection="true"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import TeklifOnayiMesajOnay from "./CellRenderers/TeklifOnayiMesajOnay.vue";
import TeklifOnayMailButton from "../components/crm-components/satis-components/TeklifOnayMailButton.vue";
import DurumGorunumCellRenderer from "./CellRenderers/DurumGorunumCellRenderer.vue";
import userJson from "../../../public/user.json";
export default {
  data() {
    return {
      rowClassRules: null,
      optionsQuality: ["Onay Alıcı", "Red Alıcı"],
      weekday: 1,
      rowSelection: null,
      localeText: null,
      teklifOnayColumns: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      teklifOnayList: [],
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      datepickerbitis: "",
      placeholderbitis: "",
      arananDeger: "",
      secilenDurum: { name: "Tümü", value: "1" },
      durumOptions: [
        { name: "Tümü", value: "1" },
        { name: "Aktif", value: "2" },
        { name: "Pasif", value: "3" },
      ],
    };
  },
  components: {
    DurumGorunumCellRenderer,
    TeklifOnayMailButton,
    TeklifOnayiMesajOnay,
    TextGorunumCellRenderer,
    AgGridVue,
    "v-select": vSelect,
  },
  methods: {
    onCellValueChanged(params) {
      try {
        const colId = params.column.getId();
        if (colId === "DESCRIPTION") {
          this.updateTeklifOnayList(params.data);
        } else if (colId === "STATUS") {
          this.updateTeklifOnayList(params.data);
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      //  this.getMalKabulList();
    },
    updateTeklifOnayList(data) {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        RECEIPTID: data.RECEIPTID,
        DESCRIPTION: data.DESCRIPTION,
        STATUS: data.STATUS == "Onay Alıcı" ? 2 : 3,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAYResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let uptResp = JSON.parse(result.INT_LS_TEKLIF_ONAYResult);
            console.log(uptResp);
            vm.getTeklifOnayList();
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
    getTeklifOnayList() {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        TRANSTYPE: "111",
        STATUS: vm.secilenDurum.value,
        ARANAN: vm.arananDeger,
      };
      soap.createClient(url, function (err, client) {
        client.INT_LS_TEKLIF_ONAY(args, function (err, result) {
          if (result.INT_LS_TEKLIF_ONAYResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_LS_TEKLIF_ONAYResult);
            vm.teklifOnayList = JSON.parse(vm.veriler.jsonData);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          } catch (error) {
            console.log(error);
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
  },
  created() {
    const data = [];

    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["employeeid"] = localStorage.getItem("employeeid");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");
    data["COMPANYNAME"] = userJson.userName;

    data["tokenId"] = localStorage.getItem("tokenId");

    data["COMPANYID"] = localStorage.getItem("COMPANYID");
    data["EMPLOYEENO"] = localStorage.getItem("EMPLOYEENO");
    data["EMAIL"] = localStorage.getItem("EMAIL");
    data["USERLONGNAME"] = localStorage.getItem("USERLONGNAME");
    var result = localStorage.getItem("tokenId").substring(1, 7);
    data["mailCode"] = result;
    data["loginpng"] = userJson.userLogo;
    data["GROUPCODE"] = localStorage.getItem("GROUPCODE");

    this.$store.commit("setToken", data);

    this.rowSelection = "single";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getTeklifOnayList();
    this.rowClassRules = {
      // row style function
      "bg-danger": (params) => {
        var numSickDays = params.data.STATUS;
        return numSickDays == "3";
      },
      "bg-success": (params) => {
        var numSickDays = params.data.STATUS;
        return numSickDays == "2";
      },
    };
  },
  mounted() {
    setTimeout(
      this.$vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      }),
      1000
    );
    //tables global olarak tanımlanıyor
    this.$root.$on("teklidOnayListesi", () => {
      this.getTeklifOnayList();
    });
  },
  beforeDestroy() {
    this.$root.$off("teklidOnayListesi");
  },
  beforeMount() {
    this.teklifOnayColumns = [
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        rowDrag: true,
        autoHeight: true,
      },

      {
        headerName: "Tarih",

        field: "TARIH",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Fiş No",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "DOCUMENTNO",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Genel Toplam",
        field: "TOTAL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Mesaj / Onay ",
        field: "NAME1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRendererFramework: "TeklifOnayiMesajOnay",
        wrapText: true,
        autoHeight: true,
      },
      {
        width: 200,
        field: "",
        cellRendererFramework: "TeklifOnayMailButton",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "İşlemi Yapan",
        field: "EMPLOYEENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true,
        editable: true,
        cellEditor: "agLargeTextCellEditor",
        cellEditorPopup: true,
        cellEditorParams: {
          maxLength: 500,
        },
      },
      {
        headerName: "Durum",
        field: "STATUS",
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: { values: this.optionsQuality },
        cellRenderer: "DurumGorunumCellRenderer",

        editable: true,
        width: 150,
      },
    ];
  },
};
</script>

<style lang="scss">
.bg-success {
  background-color: #acfcd0 !important;
}

.bg-danger {
  background-color: #f8cbcc !important;
}
</style>
